import { render, staticRenderFns } from "./ListLicenses.vue?vue&type=template&id=15c5fb38&"
import script from "./ListLicenses.vue?vue&type=script&lang=js&"
export * from "./ListLicenses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports